import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return(
    <footer>
    <h4>©2022 Happy Find by RM </h4>
    </footer>
    );
  }
}

export default Footer;
//Robert


// WEBPACK FOOTER //
// ./src/components/Footer.js